import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';
import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { LoggingService } from '@logging/logging.service';
import { ActiveAuthenticationStateService } from '@auth-n/state/active-authentication.state-service';

@Injectable({ providedIn: 'root' })
export class CintraPayrollsAccessRouteGuard implements CanActivate {
  constructor(
    private activeSecurityContext: ActiveSecurityContextStateService,
    private authenticationState: ActiveAuthenticationStateService,
    private router: Router,
    private logger: LoggingService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    this.logger.trace(
      'CintraPayrollsAccessRouteGuard: canActivate for',
      state.url,
      'isAuthenticated:',
      this.authenticationState.isAuthenticated
    );
    return this.activeSecurityContext.fetchingActiveUser$.pipe(
      filter((fetching) => fetching === false),
      take(1),
      map(() => {
        this.logger.trace(
          'CintraPayrollsAccessRouteGuard: fetchingActiveUser resolved, isAuthenticated:',
          this.authenticationState.isAuthenticated,
          'activeMembership:',
          !!this.activeSecurityContext.activeMembership
        );
        if (!this.activeSecurityContext.activeMembership && state.url.includes('under-maintenance')) return true;
        if (!this.authenticationState.isAuthenticated) {
          this.logger.trace('CintraPayrollsAccessRouteGuard: NOT authenticated, returning false for', state.url);
          return false;
        }
        if (this.activeSecurityContext.ensureCintraPayrollsAccess()) {
          return true;
        } else {
          this.logger.trace('CintraPayrollsAccessRouteGuard: No payroll access. Redirecting.');
          return this.router.parseUrl('no-permissions');
        }
      })
    );
  }
}
